/**
 * Secure logging utility for production environments
 * Prevents console.log exposure in production builds
 */

const isDevelopment = import.meta.env.MODE === 'development';

/**
 * Safe console logging wrapper - only logs in development
 */
export const logger = {
  log: (...args: unknown[]): void => {
    if (isDevelopment) {
      console.log(...args);
    }
  },

  info: (...args: unknown[]): void => {
    if (isDevelopment) {
      console.info(...args);
    }
  },

  warn: (...args: unknown[]): void => {
    if (isDevelopment) {
      console.warn(...args);
    }
  },

  error: (...args: unknown[]): void => {
    // Always log errors, even in production (for debugging)
    console.error(...args);
  },

  debug: (...args: unknown[]): void => {
    if (isDevelopment) {
      console.debug(...args);
    }
  }
};

export default logger;
